import { render, staticRenderFns } from "./topArrowIconSvg.vue?vue&type=template&id=94d33e66&"
import script from "./topArrowIconSvg.vue?vue&type=script&lang=js&"
export * from "./topArrowIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports